<template>
    <div :ref="className" v-viewer>
        <!--图片预览-->
      <img v-for="src in imgSrcList" :src="src" :key="src" v-show="false">
    </div>
</template>

<script>
export default {
    props:{
        srcList:{
            type:Array,
            default(){
                return [];
            }
        },
        src:{
            type:String,
            default(){
                return "";
            }
        }
    },
    components: {},
    data() {
        return {
            imgSrcList:[""],
            className:'homeImgView_'+new Date().getTime()
        };
    },
    computed: {},
    methods: {
        //打开图片预览模式,
        show(){
            this.$nextTick(()=>{
                if(this.src){
                    this.imgSrcList = [this.src];
                }else{
                    this.imgSrcList = this.srcList;
                }
                if(this.imgSrcList.length == 0){
                    this.$message.error("没有图片信息，无法查看");
                    return;
                }
                const viewer = this.$refs[this.className].$viewer
                viewer.show();
            })
        },
    },
    created() {},
    mounted() {},
    watch: {
        src(newVal){
            if(newVal){
                this.imgSrcList = [newVal];
            }
        }
    },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/img-view.vue